var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullScreenDarkIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 37,
    viewBox: "0 0 46 37",
    fill: "None",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2675_4587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4464 36.3892H0V23.8229H3.58087V32.8083H18.4464V36.3892Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.58087 13.7869H0V0.799072H18.3067V4.37994H3.58087V13.7869Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7966 13.7788H42.2158V4.33819L27.3066 4.33819V0.757324H45.7966V13.7788Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9707 36.4164H27.4463V32.8355H42.3329L42.3326 23.7868H45.9703C45.9704 28.719 45.9705 31.4842 45.9707 36.4164Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2675_4587"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.757324,
    width: 45.9707,
    height: 35.659,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreenDarkIn);
export default __webpack_public_path__ + "static/media/FullScreenDarkIn.24d451e495557eaf31fc076bb7094c6f.svg";
export { ForwardRef as ReactComponent };